<template lang="pug">
.container-fluid(v-if="unsupported")
  .alert.alert-danger
    | このブラウザはWebPの表示に対応していないようです。
    a(href="https://www.google.com/intl/ja_ALL/chrome/") Google Chrome
    | 、
    a(href="https://www.mozilla.org/ja/firefox/") Firefox
    | 、
    a(href="https://www.microsoft.com/ja-jp/windows/microsoft-edge") Microsoft Edge
    | などのWebP対応ブラウザの最新版でアクセスしてください。
</template>

<script>
export default {
  data() {
    return {
      unsupported: false,
    };
  },
  created() {
    const img = new Image();
    img.onload = () => {
      this.unsupported = (img.width != 1 || img.height != 1);
    };
    img.onerror = () => {
      this.unsupported = true;
    };

    // 1px WebP
    img.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
  },
}
</script>